module.exports = __webpack_public_path__ + "img/header-engagementRingsVintage.725364f.webp";